import { Typography } from '@material-ui/core'
import { FC, Fragment } from 'react'

interface ErrorMessageProps {
  error: string
}

const ErrorMessage: FC<ErrorMessageProps> = ({ error }) => (
  <Fragment>
    {error && (
      <Typography style={{ color: 'red' }} variant='body1'>
        {error}
      </Typography>
    )}
  </Fragment>
)

export default ErrorMessage
